import { GTMCategories, GTMObjectEvents } from 'google-tag-manager';
import { type GTMCustomParams, type GTMEventParams, pushGenericEventData } from './generic-event';
import { GTMSharedContextStore } from './context';
import { searchDataStore } from '../stores';
import { BundlesFareClass } from '../apis/bff/methods/bundles/constants';

export const pushBundleCardSelected = (
  hasPromoIndicator: boolean,
  isDiscounted: boolean,
  bundlePrice: number,
  bundleName?: string,
  bundleCode?: string
) => {
  const sharedContext = GTMSharedContextStore.getState();
  const defaultCurrency = searchDataStore.getState().metaData.currencyCode;
  const flightPrice = sharedContext.getBasketFlightPrice;

  const customParams: GTMCustomParams = {
    destinationUrl: '',
    genericValue1: `${isDiscounted.toString()}|${hasPromoIndicator.toString()}`,
    genericValue2: sharedContext.basket?.isoCurrencyCode || defaultCurrency || '',
    genericValue3: bundlePrice.toString(),
    genericValue4: flightPrice()
  };

  const eventActionValue = bundleName ? `Bundle: ${bundleName}` : BundlesFareClass.LIGHT;
  const eventLabelValue = bundleCode || BundlesFareClass.LIGHT;

  const eventParams: GTMEventParams = {
    eventCategory: GTMCategories.selectFareTypeModal,
    eventAction: eventActionValue,
    eventLabel: eventLabelValue,
    eventType: GTMObjectEvents.interaction,
    eventValue: ''
  };

  return pushGenericEventData(eventParams, customParams);
};
